import { useSelector } from 'react-redux';

const useSelectedClassroom = () => {
  const roster = useSelector((state: any) => state.reports?.roster);
  
  return {
    classroomId: roster?.ui?.selections?.classroom?.id,
  }

}

export default useSelectedClassroom;